import { ROLES } from "./roles";

export const CONST = {
  ...ROLES,
};
